const loadToken = () => {
  try {
    const serialized = localStorage.getItem("token");
    if (serialized === null) return undefined;

    return JSON.parse(serialized);
  } catch (err) {
    return undefined;
  }
};

const saveToken = token => {
  try {
    const serializedToken = JSON.stringify(token);
    localStorage.setItem("token", serializedToken);
  } catch (err) {}
};

const deleteToken = () => {
  try {
    localStorage.removeItem("token");
  } catch (err) {}
};

const loadUser = () => {
  try {
    const serialized = localStorage.getItem("user");
    if (serialized === null) return undefined;

    return JSON.parse(serialized);
  } catch (err) {
    return undefined;
  }
};

const saveUser = User => {
  try {
    const serializedUser = JSON.stringify(User);
    localStorage.setItem("user", serializedUser);
  } catch (err) {}
};

const deleteUser = () => {
  try {
    localStorage.removeItem("user");
  } catch (err) {}
};

export { loadToken, saveToken, deleteToken, loadUser, saveUser, deleteUser };
